module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/logo-aoj-ja-9d81f1f1e5ebac5e7549673b6e70883f.svg";